(function () {
  var DESKTOP_BREAKPOINT = 960;
  var instances = new WeakMap();
  var loadingSections = new WeakSet();

  var isDesktop = function () {
    return window.matchMedia('(min-width: ' + DESKTOP_BREAKPOINT + 'px)').matches;
  };

  var getColumnsDesktop = function (section) {
    var columns = parseInt(section.dataset.columnsDesktop, 10);

    if (!columns || columns < 1) {
      columns = parseInt(section.style.getPropertyValue('--custom-recomended-products-columns'), 10);
    }

    return columns > 0 ? columns : 3;
  };

  var getEdgeOffset = function (section) {
    var edge = parseFloat(window.getComputedStyle(section).paddingLeft);
    return edge > 0 ? edge : 0;
  };

  var updateEdgeOffset = function (section, swiper) {
    if (!swiper || !swiper.params) {
      return;
    }

    var offset = isDesktop() ? 0 : getEdgeOffset(section);

    if (swiper.params.slidesOffsetAfter !== offset) {
      swiper.params.slidesOffsetAfter = offset;
      swiper.update();
    }
  };

  var updateNavPosition = function (section) {
    if (!isDesktop()) {
      section.style.removeProperty('--custom-recomended-products-nav-top');
      return;
    }

    var referenceSlide = section.querySelector('.custom-recomended-products__slide');

    if (!referenceSlide) {
      return;
    }

    var slideHeight = referenceSlide.offsetHeight;

    if (slideHeight > 0) {
      section.style.setProperty('--custom-recomended-products-nav-top', slideHeight / 2 + 'px');
    }
  };

  var removeSection = function (section) {
    var shopifySection = section.closest('.shopify-section');

    if (shopifySection && shopifySection.parentNode) {
      shopifySection.parentNode.removeChild(shopifySection);
    }
  };

  var fetchRecommendations = function (section) {
    var sectionId = section.dataset.sectionId;
    var productId = section.dataset.productId;
    var limit = section.dataset.limit;

    if (!sectionId || !productId || !limit) {
      return Promise.resolve(false);
    }

    if (!window.theme || !window.theme.routes || !window.theme.routes.productRecommendations) {
      return Promise.resolve(false);
    }

    var requestUrl =
      window.theme.routes.productRecommendations +
      '?section_id=' +
      encodeURIComponent(sectionId) +
      '&limit=' +
      encodeURIComponent(limit) +
      '&product_id=' +
      encodeURIComponent(productId);

    return fetch(requestUrl)
      .then(function (response) {
        if (!response.ok) {
          return false;
        }

        return response.text();
      })
      .then(function (html) {
        if (!html) {
          return false;
        }

        var container = document.createElement('div');
        container.innerHTML = html;

        var fetchedSection = container.querySelector('[data-custom-recomended-products]');

        if (!fetchedSection) {
          return false;
        }

        var fetchedWrapper = fetchedSection.querySelector('.swiper-wrapper');
        var liveWrapper = section.querySelector('.swiper-wrapper');

        if (!fetchedWrapper || !liveWrapper || !fetchedWrapper.children.length) {
          return false;
        }

        liveWrapper.innerHTML = fetchedWrapper.innerHTML;

        if (fetchedSection.dataset.blocksCount) {
          section.dataset.blocksCount = fetchedSection.dataset.blocksCount;
        }

        section.classList.remove('hidden');
        return true;
      })
      .catch(function () {
        return false;
      });
  };

  var initCarousel = function (section) {
    var swiperEl = section.querySelector('.custom-recomended-products__swiper');

    if (!swiperEl || !window.Swiper || swiperEl.swiper) {
      return;
    }

    var columnsDesktop = getColumnsDesktop(section);
    var paginationEl = section.querySelector('.custom-recomended-products__pagination');
    var scrollbarEl = section.querySelector('.custom-recomended-products__scrollbar');
    var prevEl = section.querySelector('.custom-recomended-products__nav--prev');
    var nextEl = section.querySelector('.custom-recomended-products__nav--next');

    var updateFraction = function (swiper) {
      if (!paginationEl) {
        return;
      }

      var total = swiper.slides ? swiper.slides.length : 0;
      var current = Math.min((swiper.activeIndex || 0) + 1, total);
      paginationEl.textContent = total ? current + '/' + total : '';
    };

    var updateScrollbarDragSize = function (swiper) {
      if (!scrollbarEl || !swiper || !swiper.params || !swiper.params.scrollbar) {
        return;
      }

      if (!isDesktop()) {
        return;
      }

      var trackWidth = scrollbarEl.offsetWidth;

      if (!trackWidth) {
        return;
      }

      var dragSize = Math.max(1, Math.round(trackWidth * 0.04));

      if (swiper.params.scrollbar.dragSize === dragSize) {
        return;
      }

      swiper.params.scrollbar.dragSize = dragSize;

      if (swiper.scrollbar && typeof swiper.scrollbar.updateSize === 'function') {
        swiper.scrollbar.updateSize();
      }
    };

    var desktopBreakpoint = {
      slidesPerView: columnsDesktop,
      spaceBetween: 24,
    };

    if (scrollbarEl) {
      desktopBreakpoint.scrollbar = {
        enabled: true,
      };
    }

    var swiper = new Swiper(swiperEl, {
      slidesPerView: 1.4,
      spaceBetween: 16,
      speed: 600,
      watchOverflow: true,
      watchSlidesProgress: true,
      simulateTouch: true,
      grabCursor: true,
      preventClicks: true,
      preventClicksPropagation: true,
      breakpoints: {
        768: {
          slidesPerView: 2.2,
          spaceBetween: 20,
        },
        960: desktopBreakpoint,
      },
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      scrollbar: scrollbarEl
        ? {
            el: scrollbarEl,
            draggable: true,
            hide: false,
            snapOnRelease: true,
            enabled: false,
            dragSize: 1,
          }
        : undefined,
      on: {
        init: function () {
          section.querySelectorAll('.custom-recomended-products__slide img').forEach(function (img) {
            img.setAttribute('draggable', 'false');
          });

          updateEdgeOffset(section, this);
          updateNavPosition(section);
          updateFraction(this);
          updateScrollbarDragSize(this);
        },
        slideChange: function () {
          updateFraction(this);
        },
        slideChangeTransitionEnd: function () {
          updateNavPosition(section);
        },
        resize: function () {
          updateEdgeOffset(section, this);
          updateNavPosition(section);
          updateScrollbarDragSize(this);
        },
        breakpoint: function () {
          updateEdgeOffset(section, this);
          updateNavPosition(section);
          updateScrollbarDragSize(this);
        },
      },
    });

    var onResize = function () {
      updateEdgeOffset(section, swiper);
      updateNavPosition(section);
      updateScrollbarDragSize(swiper);
    };

    var onImagesLoaded = function () {
      updateNavPosition(section);
    };

    window.addEventListener('resize', onResize);

    section.querySelectorAll('.custom-recomended-products__slide img').forEach(function (img) {
      if (img.complete) {
        return;
      }

      img.addEventListener('load', onImagesLoaded, { once: true });
    });

    instances.set(section, {
      swiper: swiper,
      onResize: onResize,
    });

    updateNavPosition(section);

    return swiper;
  };

  var destroyCarousel = function (section) {
    var instance = instances.get(section);

    if (!instance) {
      return;
    }

    if (instance.onResize) {
      window.removeEventListener('resize', instance.onResize);
    }

    if (instance.swiper) {
      instance.swiper.destroy(true, true);
    }

    instances.delete(section);
    section.style.removeProperty('--custom-recomended-products-nav-top');
  };

  var initSection = function (section) {
    if (!section || instances.has(section) || loadingSections.has(section)) {
      return;
    }

    var wrapper = section.querySelector('.swiper-wrapper');
    var hasSlides = wrapper && wrapper.children.length > 0;

    var start = function () {
      if (!window.Swiper) {
        return false;
      }

      if (!wrapper || !wrapper.children.length) {
        removeSection(section);
        return true;
      }

      initCarousel(section);

      if (typeof ProductItem === 'function') {
        ProductItem(section, { afterLoad: true });
      }

      // Wayvia binds .ps-widget only on first paint; rebind after AJAX slides.
      if (typeof window.rebindWayviaWidgets === 'function') {
        window.rebindWayviaWidgets();
      } else if (window.PriceSpider && typeof window.PriceSpider.rebind === 'function') {
        window.PriceSpider.rebind();
      } else {
        document.dispatchEvent(new CustomEvent('wayvia:rebind'));
      }

      return true;
    };

    if (hasSlides) {
      start();
      return;
    }

    loadingSections.add(section);

    fetchRecommendations(section)
      .then(function (loaded) {
        if (!loaded) {
          removeSection(section);
          return;
        }

        start();
      })
      .finally(function () {
        loadingSections.delete(section);
      });
  };

  var initSections = function (root) {
    if (!window.Swiper) {
      return;
    }

    var scope = root || document;

    scope.querySelectorAll('[data-custom-recomended-products]').forEach(function (section) {
      initSection(section);
    });
  };

  var destroySections = function (root) {
    var scope = root || document;

    scope.querySelectorAll('[data-custom-recomended-products]').forEach(function (section) {
      destroyCarousel(section);
    });
  };

  var bootstrap = function () {
    initSections();

    if (window.Swiper) {
      return;
    }

    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;

      if (window.Swiper) {
        window.clearInterval(timer);
        initSections();
      } else if (attempts > 50) {
        window.clearInterval(timer);
      }
    }, 100);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initSections(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroySections(event.target);
  });
})();
